import { render, staticRenderFns } from "./PlaceCard.vue?vue&type=template&id=d51e5f2e&scoped=true"
import script from "./PlaceCard.vue?vue&type=script&lang=js"
export * from "./PlaceCard.vue?vue&type=script&lang=js"
import style0 from "./PlaceCard.vue?vue&type=style&index=0&id=d51e5f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51e5f2e",
  null
  
)

export default component.exports